import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface Workspace {
  id: string;
  name: string;
  slug: string;
}

interface WorkspaceState {
  currentWorkspace: Workspace | null;
  setWorkspace: (workspace: Workspace) => void;
  clearWorkspace: () => void;
}

export const useWorkspaceStore = create<WorkspaceState>()(
  persist(
    (set) => ({
      currentWorkspace: null,
      setWorkspace: (workspace) => {
        localStorage.setItem('workspaceId', workspace.id);
        set({ currentWorkspace: workspace });
      },
      clearWorkspace: () => {
        localStorage.removeItem('workspaceId');
        set({ currentWorkspace: null });
      },
    }),
    {
      name: 'workspace-storage',
    }
  )
);

